export default class StaticCart {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    $('.get-rates').on('click', () => this.getRates());
    $('.cart-instructions textarea').on('change', () => this.saveSpecialInstructions());
    this.initializedClass = 'cart-initialized';
    this.hasShippingCalculator = section.data.hasShippingCalculator;
    this._validate();
  }

  update() {
    // Resets the @$el for the current closure
    this._validate();
  }

  onSectionUnload() {
    $('.get-rates').off('click');
    $('.cart-instructions textarea').off('change');
  }

  _validate() {
    if (this.hasShippingCalculator) {
      this.shippingCalculator();
      if (Theme.customerLoggedIn && Theme.customerAddress && Theme.customerAddress.country) {
        this.calculateShipping(true);
      }
    }

    return Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  saveSpecialInstructions() {
    const newNote = $('.cart-instructions textarea').val();
    return Shopify.updateCartNote(newNote, (cart) => {
      // empty function so that Shopify's callback isn't invoked
    });
  }

  updateShippingLabel(select) {
    if (select) {
      select = $(select);
      const selectedVariant = select.find('option:selected').val();
      select.prev('.selected-option').text(selectedVariant);
    }
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: Theme.shippingButton,
      submitButtonDisabled: Theme.shippingDisabled,
      customerIsLoggedIn: Theme.customerLoggedIn,
      moneyFormat: Theme.moneyFormat,
    });

    const selectableOptions = $('.cart-shipping-calculator select');

    setTimeout(() => {
      selectableOptions.map((index, select) => this.updateShippingLabel(select));
    },
    1);

    /* TODO: A race condition here prevents the state/province select
     * from updating when the country changes (since at least v4.0.0).
     * I've added a timeout as a temporary fix, but we should find a
     * more reliable solution.
     * */
    selectableOptions.change((e) => {
      selectableOptions.each((index, select) => {
        setTimeout(() => {
          this.updateShippingLabel(select);
        }, 1);
      });
    });
  }

  getRates() {
    return this.calculateShipping();
  }

  calculateShipping(auto) {
    let shippingAddress;
    const shippingCalculatorResponse = $('.cart-shipping-calculator-response', this.$el);
    shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
    const ratesFeedback = $('.shipping-calculator-response');

    $('.get-rates', this.$el).val(Theme.shippingDisabled);

    if (auto) {
      shippingAddress = Theme.customerAddress;
    } else {
      shippingAddress = {
        zip: $('.address-zip', this.$el).val() || '',
        country: $('.address-country', this.$el).val() || '',
        province: $('.address-province', this.$el).val() || '',
      };
    }

    Shopify.getCartShippingRatesForDestination(shippingAddress, (rates) => {
      let response;
      $('.shipping-rates').empty();
      let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
      if (!shippingAddress.province.length) {
        address = `${shippingAddress.zip}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.zip.length) {
        address = `${shippingAddress.province}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.province.length || !shippingAddress.zip.length) {
        address = shippingAddress.country;
      }

      if (rates.length > 1) {
        const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
        response = Theme.shippingCalcMultiRates.replace('**address**', address).replace('**number_of_rates**', rates.length).replace('**rate**', `<span class='money'>${firstRate}</span>`);
        ratesFeedback.html(response);
      } else if (rates.length === 1) {
        response = Theme.shippingCalcOneRate.replace('**address**', address);
        ratesFeedback.html(response);
      } else {
        ratesFeedback.html(Theme.shippingCalcNoRates);
      }

      for (let i = 0; i < rates.length; i++) {
        const rate = rates[i];
        const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        const rateValues = Theme.shippingCalcRateValues.replace('**rate_title**', rate.name).replace('**rate**', `<span class='money'>${price}</span>`);
        $('.shipping-rates').append(`<li>${rateValues}</li>`);
      }

      return $('.get-rates').val(Theme.shippingButton);
    });
  }

  handleErrors(errors) {
    let errorMessage = $.parseJSON(errors.responseText);
    errorMessage = Theme.shippingCalcErrorMessage.replace('**error_message**', errorMessage.zip);
    $('.cart-shipping-calculator-response').html(`<p>${errorMessage}</p>`);
    return $('.get-rates').val(Theme.shippingButton);
  }
}
